import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUserData } from '../hooks';
import styles from './BottomNav.module.css';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isBrokerOwner } = useUserData();

  const menuItems = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      path: '/app/dashboard',
      icon: '🏠'
    },
    {
      id: 'mls-gpt',
      title: 'MLS GPT',
      path: '/app/mls-gpt',
      icon: '🤖'
    },
    {
      id: 'mls-chat',
      title: 'MLS Chat',
      path: '/app/chat',
      icon: '💬'
    },
    {
      id: 'search-map',
      title: 'Map',
      path: '/app/map-search',
      icon: '🗺️'
    },
    {
      id: 'cma-from-scratch',
      title: 'CMA',
      path: '/app/cma-from-scratch',
      icon: '📊'
    },
    {
      id: 'tax-record-search',
      title: 'Tax',
      path: '/app/tax-record-search',
      icon: '📋'
    },
    ...(isBrokerOwner ? [{
      id: 'broker-dashboard',
      title: 'Broker',
      path: '/app/broker',
      icon: '🧾'
    }] : [])
  ];

  const isActive = (path) => {
    if (path === '/app/dashboard') {
      return location.pathname === '/app' || location.pathname === '/app/' || location.pathname === '/app/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className={styles.bottomNav}>
      {menuItems.map((item) => (
        <button
          key={item.id}
          onClick={() => navigate(item.path)}
          className={`${styles.bottomNavItem} ${isActive(item.path) ? styles.active : ''}`}
          aria-label={item.title}
        >
          <span className={styles.bottomNavIcon}>{item.icon}</span>
          <span className={styles.bottomNavLabel}>{item.title}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;

